import React from 'react';
import {
    View,
} from 'react-native';

import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPeopleGroup, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import MyAppText from '../../components/MyAppText';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';
import PlateImage from './PlateImage';
import { faCameraCctv, faMotorcycle } from '@fortawesome/pro-solid-svg-icons';
import MyInfinityDataTable from '../MyInfinityDataTable';
import Badge from '../Badge';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { RootNavigation } from '../../Routes';

interface EventListProps {
    events: LprDetection[];
    navigation: RootNavigation;
    isLoading: boolean;
    loadMore?: () => void;
    page: 'live-events' | 'live-alerts' | 'search' | 'map';
}

export default function EventList({ events, navigation, isLoading, loadMore, page }: EventListProps) {
    const { theme, styles } = useStyles(stylesheet);

    return <MyInfinityDataTable
        progressPending={isLoading}
        data={events}
        onRowPress={row => {
            if (page == 'live-alerts') {
                return navigation.navigate('LPR', {
                    screen: 'LiveAlertLprDetection', params: {
                        detectionId: row.id,
                    }
                });
            }
            if (page == 'live-events') {
                return navigation.navigate('LPR', {
                    screen: 'LiveEventLprDetection', params: {
                        detectionId: row.id,
                    }
                });
            }
            if (page == 'search') {
                return navigation.navigate('LPR', {
                    screen: 'SearchLprDetection', params: {
                        detectionId: row.id,
                    }
                });
            }
        }}
        columns={[{
            name: '',
            cell: row => <PlateImage
                src={row.imageUrl}
                platePosition={row.platePosition}
            />,
            width: 150,
        }, {
            name: translate('plate'),
            selector: row => row.plate,
            width: 150,
        }, {
            name: translate('information'),
            cell: row => <View style={{ rowGap: 10 }}>
                {row.description ?
                    <MyAppText style={styles.headerCell}>{row.description}</MyAppText> : null
                }
                <View style={{ flexDirection: 'row' }}>
                    {row.violation &&
                        <Badge mode='ROUNDED' backgroundColor={theme.colors.badges.red.backgroundColor} textColor={theme.colors.badges.red.textColor}>
                            {row.violation === 'on_phone' ? translate('onPhone') : translate('withoutBelt')}
                        </Badge>
                    }
                </View>
            </View>,
            flex: 2,
        }, {
            name: translate('location'),
            flex: 1,
            cell: row => <View style={{ flexBasis: '20%', rowGap: 10, paddingVertical: 8 }}>
                <View style={styles.locationView} >
                    <FontAwesomeIcon icon={faCalendarCheck} fontSize={13} style={styles.locationIcon} />
                    <MyAppText style={styles.locationText}>
                        {moment(new Date(row.time)).format('DD/MM/YYYY HH:mm:ss')}
                    </MyAppText>
                </View>

                {row.camera && <>
                    <View style={styles.locationView} >
                        <FontAwesomeIcon icon={faLocationDot} fontSize={13} style={styles.locationIcon} />
                        <MyAppText style={styles.locationText}>
                            {row.camera.address}
                        </MyAppText>
                    </View>

                    <View style={styles.locationView} >
                        <FontAwesomeIcon icon={faCameraCctv as IconDefinition} fontSize={13} style={styles.locationIcon} />
                        <MyAppText style={styles.locationText}>
                            {row.camera.title}
                        </MyAppText>
                    </View>
                </>}
                {row.unitName && <>
                    <View style={styles.locationView}>
                        <FontAwesomeIcon icon={faPeopleGroup} style={styles.locationIcon} />
                        <MyAppText style={styles.locationText}>
                            {translate('eventRegisteredByUnit', { unitName: row.unitName.name })}
                        </MyAppText>
                    </View>
                    <View style={styles.locationView} >
                        <FontAwesomeIcon icon={faMotorcycle as IconDefinition} fontSize={13} style={styles.locationIcon} />
                        <MyAppText style={styles.locationText}>{translate('plateDetectedByMobileAgentAlert')}</MyAppText>
                    </View>
                </>}
            </View>
        }]}
        loadMore={loadMore || (() => { })}
    />;
}

const stylesheet = createStyleSheet(theme => ({
    headerCell: {
        fontSize: 14,
        color: theme.colors.labelColor,
    },
    locationView: {
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: 5
    },
    locationIcon: {
        color: theme.colors.textColor,
    },
    locationText: {
        color: theme.colors.disabledText,
        fontWeight: '500',
    },
}));
